<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item label="商家编号" prop="userid">
            <el-input v-model="queryForm.userid" placeholder="请输入商家编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="用户名称" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="所属业务员" prop="personName">
            <el-input v-model="queryForm.personName" placeholder="请输入所属业务员"/>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="分站" prop="ownerWeb">
            <el-input v-model="queryForm.ownerWeb" placeholder="请输入分站信息"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="关联银行卡" prop="backCardNum">
            <el-select v-model="queryForm.backCardNum" clearable placeholder="请选择绑定银行卡">
              <el-option
                  v-for="item in backOptions"
                  :key="item.backCardNum"
                  :label="item.backCardName"
                  :value="item.backCardNum"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="注册时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="4">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-button v-show="isShowAccessField(4)" type="primary" size="small" style="margin: 0 0 10px 20px"
                @click="handleAdd('设置银行卡')" plain>设置银行卡
    </el-button>
    <el-button v-show="isShowAccessField(5)" type="success" size="small" style="margin: 0 0 10px 20px"
               @click="handleExpressAdd('充值点数')" plain>充值点数
    </el-button>
    <el-button v-show="isShowAccessField(6)" type="primary" size="small" style="margin: 0 0 10px 20px"
               @click="handleShopAdd('绑定店铺个数')" plain>绑定店铺个数
    </el-button>
    <el-button v-show="isShowAccessField(3)" type="primary" size="mini" style="margin: 0 0 10px 20px"
               @click="handleImportData('导入用户数据')">导入商家</el-button>

    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="userid" label="用户ID" width="180" >
        <!--<template slot-scope="scope" >
          <span style="text-align: center">{{getStrEndWithNumbers(scope.row.userid)}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="userName" label="用户名" />
      <el-table-column prop="balanceMoney" label="余额" />
      <el-table-column prop="disenableMoney" label="冻结" />
      <el-table-column label="店铺" >
        <template slot-scope="scope" >
          <span style="text-align: center">{{scope.row.alreadyUserShops}}/{{scope.row.bindShops}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="expressPointNum" label="物流点数" />
      <el-table-column prop="isTaoEnabled" label="淘宝业务" >
      <template slot-scope="scope" >
        <span style="text-align: center">{{scope.row.isTaoEnabled?"开启":"关闭"}}</span>
      </template>
      </el-table-column>
      <el-table-column prop="isAssignBusiness" label="是否指派业务" style="text-align: center">
        <template slot-scope="scope">
          <span style="text-align: center">{{scope.row.isAssignBusiness?"是":"否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isDownPayment" label="降权包赔" style="text-align: center">
        <template slot-scope="scope">
          <span style="text-align: center">{{scope.row.isDownPayment?"开启":"关闭"}}</span>
        </template>
      </el-table-column>
      <!-- 商返权限 -->
      <el-table-column prop="enableBusinessReturnMoney" label="商返权限" style="text-align: center">
        <template slot-scope="scope">
          <span style="text-align: center">{{scope.row.enableBusinessReturnMoney?"开启":"关闭"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="discountNumber" label="折率" />
      <el-table-column prop="contactUser" label="联系人" />
      <el-table-column prop="registerTime" label="注册时间" width="100"/>
      <el-table-column prop="upUserShareCode" label="上级ID" />
      <el-table-column prop="personName" label="业务员" />
      <el-table-column prop="ownerWeb" label="所属分站">
        <template slot-scope="scope">
          <span>{{scope.row.ownerWeb|strFilterSpace }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusStr" label="状态" >
        <template slot-scope="scope">
          <span style="color: #44b1eb">{{scope.row.statusStr}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ownerBackInfo" label="关联银行" width="120"/>
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain
                     @click="handleSettingEdit(scope.$index, scope.row)">
            设置
          </el-button>
          <el-button size="mini" type="primary" plain
                     @click="handleBusinessEdit(scope.$index, scope.row)">
            设置业务员
          </el-button>
          <el-button size="mini" type="success" style="margin-top: 5px;" plain
                     @click="handleLoginBusiness(scope.$index, scope.row)">
            登录
          </el-button>
          <el-button size="mini" type="primary" style="margin-top: 5px;" plain
                     @click="goToDetail(scope.$index, scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="银行卡" prop="payBack">
            <el-select v-model="dialogForm.backCardNum" clearable placeholder="请选择">
              <el-option
                  v-for="item in backOptions"
                  :key="item.id"
                  :label="item.backCardName"
                  :value="item.backCardNum"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogForm()" size="mini" type="primary">确认设置</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogExpressTitle" :visible.sync="dialogExpressFormVisible">
    <el-form ref="dialogExpressForm" :model="dialogExpressForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="请选择充值物流" prop="payBack">
            <el-select v-model="dialogExpressForm.b2cExpressManageId" clearable placeholder="请选择">
              <el-option
                  v-for="item in expressOptions"
                  :key="item.id"
                  :label="item.expressName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="充值点数" prop="investMoney">
            <el-input v-model="dialogExpressForm.investExpress" placeholder="输入点数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="合计金额">
            <span style="color: red">{{getPriceWithExpress}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogExpresForm()" size="mini" type="primary">确认充值</el-button>
      <el-button @click="handleCloseExpresDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :visible.sync="dialogShopFormVisible">
    <template v-slot:title>
      <div><span style="color: red">[全部商家]</span>{{dialogShopTitle}}</div>
    </template>
    <el-form ref="dialogShopForm" :model="dialogShopForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="绑定店铺" prop="bindShops">
            <el-input v-model="dialogShopForm.bindShops" placeholder="输入店铺数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogShopForm()" size="mini" type="primary">确认设置</el-button>
      <el-button @click="handleCloseShopDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogBusinessTitle" :visible.sync="dialogBusinessFormVisible">
    <el-form ref="dialogBusinessForm" :model="dialogBusinessForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="设置业务员" prop="bindShops">
            <el-input v-model="dialogBusinessForm.personName" placeholder="输入业务员"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogBusinessForm()" size="mini" type="primary">确认设置</el-button>
      <el-button @click="handleCloseBusinessDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogSettingTitle" :visible.sync="dialogSettingFormVisible">
    <el-form ref="dialogSettingForm" :model="dialogSettingForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="绑定店铺" prop="payBack">
            <el-input v-model="dialogSettingForm.bindShops" placeholder="输入店铺数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="淘宝业务" prop="isTaoEnabled">
            <el-radio-group v-model="dialogSettingForm.isTaoEnabled">
              <el-radio :label="false">关闭</el-radio>
              <el-radio :label="true">开启</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 新增商家返款设置 -->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="商返权限" prop="enableBusinessReturnMoney">
            <el-radio-group v-model="dialogSettingForm.enableBusinessReturnMoney">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- end -->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="指派业务" prop="isAssignBusiness">
            <el-radio-group v-model="dialogSettingForm.isAssignBusiness">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="降权包赔" prop="isDownPayment">
            <el-radio-group v-model="dialogSettingForm.isDownPayment">
              <el-radio :label="false">关闭</el-radio>
              <el-radio :label="true">开启</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="佣金折率" prop="payBack">
            <el-input v-model="dialogSettingForm.discountNumber" placeholder="输入佣金折率"></el-input>
            <span>（即基础服务费折率，介于0~1之间，1为不打折）</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogSettingForm()" size="mini" type="primary">确认</el-button>
      <el-button @click="handleCloseSettingDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogImportDataTitle" :visible.sync="dialogImportDataFormVisible">
    <el-form ref="dialogImportDataForm" :model="dialogImportDataForm" label-width="220px">
      <el-row :gutter="20">
        <el-col :span="24" style="text-align: center">
          <el-link target="_blank" href="https://myb2c.oss-cn-hangzhou.aliyuncs.com/dataimporttemplate/businessTemplate.xlsx" :underline="false">
            <el-button style="margin-bottom: 2%;" type="primary" plain >下载模版</el-button>
          </el-link>
          <div style="color: red;max-width: 90%;margin-left:2%;text-align: center;">
            <span>模版为商家信息导入模版。如果增加其他角色，请联系管理</span>
            <div> 如果有上下级关系， 请先导入最上级用户。切记</div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :span="24" style="text-align: center;">
          <el-upload
              class="avatar-uploader"
              drag
              action="https://api.weiquanai.com/b2cmanagepersons/business/upload"
              :headers="myheader"
              :show-file-list="false"
              accept=".xlsx"
              :before-upload="onbeforeunloads"
              :on-success="importDataSuccess"
              :on-error="importDataError">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.xlsx文件，且不超过50MB</div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import {getAllStore, getStores, updateStore, deleteStore, addStore, addAllShops, updateManagerPerson} from '../../api/b2cbusiness/storelist'
import MixinCUD from '@/components/MixinCUD'
import {getAllB2cBackCardSys, updateB2cBackCardByIds} from "../../api/b2cbusiness/b2c_backcardmanage";
import {addExpressUserManage, getAllListExpress} from "../../api/b2cbusiness/b2c_express";
import {decryptPassword, getJwtToken, getStrEndWithNumbers} from "../../lib/utils";
import {queryAdminLoginUser} from "../../api/b2cbusiness/b2c_customerinfo";
import {Loading} from "element-ui";
import {queryRoleAccessField} from "@/api/system/sys_role";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "storelist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      myheader: {
        JWTHeaderName: ""
      },
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
        userid: null,
        userName: '',
        personName: '',
        ownerWeb: '',
        backCardNum: null,
        timeRange: []
      },
      dialogFormVisible: false,
      dialogTitle:"",
      dialogRefName:"dialogForm",
      dialogForm: {

      },
      backOptions:[],
      multipleSelection: [],
      dialogExpressFormVisible: false,
      dialogExpressTitle:"",
      dialogExpressRefName:"dialogExpressForm",
      dialogExpressForm: {

      },
      dialogShopFormVisible: false,
      dialogShopTitle:"",
      dialogShopRefName:"dialogShopForm",
      dialogShopForm: {

      },
      expressOptions:[],
      dialogSettingFormVisible: false,
      dialogSettingTitle:"",
      dialogSettingRefName:"dialogSettingForm",
      dialogSettingForm: {

      },
      dialogBusinessFormVisible: false,
      dialogBusinessTitle:"",
      dialogBusinessRefName:"dialogBusinessForm",
      dialogBusinessForm: {

      },
      dialogImportDataFormVisible: false,
      dialogImportDataTitle: "导入用户数据",
      dialogImportDataRefName: "dialogImportDataForm",
      dialogImportDataForm:{
      },
      loadingInstance:null,
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      dialogFormRules: {
      },
      b2cAccessFieldInfos: []
    }
  },
  filters:{
    strFilterSpace: function (val) {
      if (val == ""){
        return null;
      }
      return val;
    }
  },
  computed:{
    isShowAccessField(){
      return function (fieldId) {
        if (this.b2cAccessFieldInfos.length <= 0){
          return false;
        }else{
          return this.b2cAccessFieldInfos.filter(item => item.id == fieldId).length > 0;
        }
      }
    },
    getPriceWithExpress(){
      console.log(this.expressOptions)
      if (this.dialogExpressForm.b2cExpressManageId > 0 && this.dialogExpressForm.investExpress != null){
        console.log(this.dialogExpressForm.b2cExpressManageId)
        let expressInfo = this.expressOptions.find(item=>item.id == this.dialogExpressForm.b2cExpressManageId);
        console.log(expressInfo);
        return this.dialogExpressForm.investExpress + " X " + expressInfo.expressPrice+"="+this.dialogExpressForm.investExpress * expressInfo.expressPrice;
      }else{
        return 0;
      }
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    //this.tableHeight = document.body.clientHeight - 220;
    getAllListExpress().then(res=>{
      console.log(res.data);
      if (res.success){
        this.expressOptions = res.data;
      }
    });
    getStores({}, this.pagination).then(res=>{
      console.log(res.data)
      if (res.success){
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    getAllB2cBackCardSys().then(res=>{
      console.log(res.data);
      if (res.success){
        this.backOptions = res.data;
      }
    });

    /*获取字段权限*/
    queryRoleAccessField("商家列表", null).then(res => {
      if (res.success){
        this.b2cAccessFieldInfos = res.data;
        //console.log(this.b2cAccessFieldInfos)
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  methods:{
    onbeforeunloads(file){
      this.loadingInstance = Loading.service({text:"上传处理中"});
    },
    importDataSuccess(res, file){
      console.log(res, file);
      if (res.success){
        this.$message.success("导入数据成功");
        this.loadingInstance.close();
        this.dialogImportDataFormVisible = false;
        this.getData();
        this.$forceUpdate();
      }
    },
    importDataError(err, file, fileList){
      this.$message({message: err.message, type: 'error'});
      this.loadingInstance.close();
    },
    handleLoginBusiness(index, data){
      queryAdminLoginUser({b2cUsersId:data.userid}).then(res=>{
        if (res.success){
          console.log(res.data)
          //this.$router.push({name:'login', params:{userName:res.data.userName, password:res.data.userPassword}});
          window.open("http://sj.usmartdoc.com?username="+res.data.userName+"&password="+res.data.userPassword, "_blank");
          //window.open("https://api.weiquanai.com?username="+res.data.userName+"&password="+res.data.userPassword, "_blank");
        }
      });
    },
    handleImportData(dialogTitle){
      this.dialogImportDataFormVisible = true;
      this.dialogImportDataTitle = dialogTitle
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    goToDetail(index, data){
      this.$router.push({path:"/home/storedetail", query: {userId:data.userid}})
    },
    submitDialogBusinessForm(){
      updateManagerPerson(this.dialogBusinessForm).then(res=>{
        console.log(res.data)
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          this.submitQueryForm();//新增之后，重新查询table
          this.handleCloseBusinessDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleCloseBusinessDialog(){
      this.$refs[this.dialogBusinessRefName].resetFields();
      this.dialogBusinessFormVisible = false;
    },
    handleBusinessEdit(index, row, dialogTitle) {
      this.dialogBusinessFormVisible = true;
      this.dialogBusinessTitle = dialogTitle
      this.resetBusinessDialogForm()
      this.dialogBusinessForm = {...row}
    },
    resetBusinessDialogForm(){
      for(let item in this.dialogBusinessForm){
        if (typeof this.dialogBusinessForm[item]==='string'){
          this.dialogBusinessForm[item]='';
        } else if (this.dialogBusinessForm[item] instanceof Array) {
          this.dialogBusinessForm[item]=[];
        } else{
          this.dialogBusinessForm[item]=null
        }
      }
    },

    submitDialogSettingForm(){
      updateStore(this.dialogSettingForm).then(res=>{
        console.log(res.data)
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          this.submitQueryForm();//新增之后，重新查询table
          this.handleCloseSettingDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleCloseSettingDialog(){
      this.$refs[this.dialogSettingRefName].resetFields();
      this.dialogSettingFormVisible = false;
    },
    handleSettingEdit(index, row, dialogTitle) {
      this.dialogSettingFormVisible = true;
      this.dialogSettingTitle = dialogTitle
      this.resetSettingDialogForm()
      this.dialogSettingForm = {...row}
    },
    resetSettingDialogForm(){
      for(let item in this.dialogSettingForm){
        if (typeof this.dialogSettingForm[item]==='string'){
          this.dialogSettingForm[item]='';
        } else if (this.dialogSettingForm[item] instanceof Array) {
          this.dialogSettingForm[item]=[];
        } else{
          this.dialogSettingForm[item]=null
        }
      }
    },
    submitDialogShopForm(){
      addAllShops(this.dialogShopForm).then(res=>{
        console.log(res.data)
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          this.submitQueryForm();//新增之后，重新查询table
          this.handleCloseShopDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleCloseShopDialog(){
      this.$refs[this.dialogShopRefName].resetFields();
      this.dialogShopFormVisible = false;
    },
    handleShopAdd(dialogTitle){
      this.dialogShopFormVisible = true;
      this.dialogShopTitle = dialogTitle
      this.resetShopDialogForm()
    },
    resetShopDialogForm(){
      for(let item in this.dialogShopForm){
        if (typeof this.dialogShopForm[item]==='string'){
          this.dialogShopForm[item]='';
        } else if (this.dialogShopForm[item] instanceof Array) {
          this.dialogShopForm[item]=[];
        } else{
          this.dialogShopForm[item]=null
        }
      }
    },
    submitDialogExpresForm(){
      console.log(this.multipleSelection)
      if (this.multipleSelection.length > 0 && this.multipleSelection.length < 2) {
        this.dialogExpressForm.b2cUsersId = this.multipleSelection[0].userid;
        addExpressUserManage(this.dialogExpressForm).then(res => {
          this.$message({message: res.data, type: 'success'});
          this.submitQueryForm();//新增之后，重新查询table
          this.handleCloseExpresDialog();
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }else{
        this.$message({message: "请选择要充值的商家,或者你多选了（只能选一个）", type: 'error'});
      }
    },
    handleCloseExpresDialog(){
      this.$refs[this.dialogExpressRefName].resetFields();
      this.dialogExpressFormVisible = false;
    },
    handleExpressAdd(dialogTitle){
      this.dialogExpressFormVisible = true;
      this.dialogExpressTitle = dialogTitle
      this.resetExpressDialogForm()
    },
    resetExpressDialogForm(){
      for(let item in this.dialogExpressForm){
        if (typeof this.dialogExpressForm[item]==='string'){
          this.dialogExpressForm[item]='';
        } else if (this.dialogExpressForm[item] instanceof Array) {
          this.dialogExpressForm[item]=[];
        } else{
          this.dialogExpressForm[item]=null
        }
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    addData(){
      console.log(this.multipleSelection)
      if (this.multipleSelection.length > 0){
        this.dialogForm.ids = this.multipleSelection.map(item=>{
          console.log(item)
          return item.userid;
        });
        console.log(this.dialogForm)
        updateB2cBackCardByIds(this.dialogForm).then(res=>{
          if (res.success){
            this.$message({message: res.data, type: 'success'});
            this.submitQueryForm();//新增之后，重新查询table
            this.handleCloseDialog();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }else{
        this.$message({message: err.message, type: 'error'});
      }
    },
    getData(){
      getStores(this.queryForm, this.pagination).then(res=>{
        console.log(res.data)
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
